import JSX from "../../helpers/react.js";
import RefObject = JSX.RefObject;
export interface ISelectValue{
    name: string;
    value: string|number;
    selected: boolean;
    dataSortOrder?: string;
}
type OnSelectChange = (...selectedValues: ISelectValue[])=>any;

export function Select(props: {name: string, multiple: true ,placeholder: string, onChange?: OnSelectChange, direction?:'down'|'up', ref?: RefObject, initSelect?: boolean, style?: any}, values: (ISelectValue)[]):any;
export function Select(props: {name: string, multiple: false ,placeholder: string, onChange?: (v: ISelectValue|undefined)=>any, ref?: RefObject, direction?:'down'|'up', initSelect?: boolean, style?: any}, values: (ISelectValue)[]): any;

export function Select({name, multiple, placeholder, onChange, ref, direction, initSelect, style}: {name: string, multiple: boolean,placeholder: string, onChange?: OnSelectChange, ref?: RefObject, direction?: 'down'|'up', initSelect?: boolean, style?: any}, values: (ISelectValue)[]){
    values = values.filter(e=>e);
    const select: RefObject<HTMLSelectElement> = {};
    if(initSelect !== false) {
        if (multiple) onChange?.(...values.filter(r => r.selected))
        //@ts-ignore
        else onChange?.(values.find(e => e.selected) ?? undefined)
    }
    const ans = (
        <select
            name={name}
            className="bordered-overflow"
            multiple={multiple?'':undefined}
            data-placeholder={placeholder}
            ref={select}
            style={style}
            data-direction={direction}
            onChange={()=>{
                const selectedValues = new Set(
                    Array.from(select.value!.children as any as HTMLOptionElement[])
                        .filter(e=>e.selected)
                        .map(e=>e.value)
                );
                onChange?.(...values.filter(e=>selectedValues.has(e.value+"")))
            }}
        >
        {
            ...values.map(({name, value, selected,dataSortOrder}) => (
                <option
                    value={value}
                    selected={selected?'selected':undefined}
                    data-sort-order={dataSortOrder}>
                    {name}
                </option>
            ))
        }
        </select>
    );
    if(ref) ref.value = select.value;
    setTimeout(()=>{
        if(select.value?.nextElementSibling && values.length === 1){
            select.value.nextElementSibling.classList.add("disabled");
        }
    })
    return ans;
}
